import * as React from 'react';
export const IcCode = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.71 7.29a.996.996 0 00-1.41 0l-4.01 4a.996.996 0 000 1.41l4 4c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 000-1.41L4.42 12l3.29-3.29a.996.996 0 000-1.41v-.01zm14 4l-4-4A.996.996 0 1016.3 8.7l3.29 3.29-3.29 3.29a.996.996 0 00.71 1.7c.26 0 .51-.1.71-.29l4-4a.996.996 0 000-1.41l-.01.01zm-7.43-7.25c-.53-.15-1.08.16-1.24.69l-4 14a1.012 1.012 0 00.97 1.28c.44 0 .84-.29.96-.73l3.99-14.01c.15-.53-.16-1.08-.69-1.24l.01.01z'
      fill='currentColor'
    />
  </svg>
);
